import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import MeetingID from '@/App/Booking/Meeting/Entity/MeetingID'
import ReservationID from '@/App/Booking/Reservation/Entity/ReservationID'
import CompanyCustomerID from '@/App/Company/Entity/CompanyCustomerID'
import { type ReservationRawData } from '@/Shared/AutoGenerated/Main'

export default class Reservation {
    constructor(
        public readonly id: ReservationID,
        public readonly companyCustomerId: CompanyCustomerID,
        public readonly selectedTimeZone: string,
        public readonly numberOfSeatsReserved: number,
        public readonly notes: string | null,
        // Computed
        public readonly dateTimeFormatted: string,
        public readonly dateFormatted: string,
        public readonly startAtFormatted: string,
        public readonly endAtFormatted: string,
        public readonly cannotRefund: boolean,
        public readonly cannotReschedule: boolean,
    ) {
        ensureNoUndefinedProperties(this)
    }

    getNumberOfReservedSeatsLabel(): string {
        if (this.numberOfSeatsReserved === 1) {
            return '1 seat'
        }

        return `${this.numberOfSeatsReserved} seats`
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingle(entityData: ReservationRawData): Reservation {
        return new Reservation(
            new ReservationID(entityData.id),
            new CompanyCustomerID(entityData.companyCustomerId),
            entityData.selectedTimeZone,
            entityData.numberOfSeatsReserved,
            entityData.notes,
            // Computed
            entityData.dateTimeFormatted,
            entityData.dateFormatted,
            entityData.startAtFormatted,
            entityData.endAtFormatted,
            entityData.cannotRefund,
            entityData.cannotReschedule,
        )
    }

    static hydrateMultiple(entitiesData: ReservationRawData[]): Reservation[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
